import { ANGLE_EPSILON } from "geom/core";
import { line2MidPt } from "geom/line2";
import type { PolyLine2 } from "geom/polyLine2Types";
import type { Vec2 } from "geom/vec2";
import { vec2AngleBetweenCWSimple, vec2Sub } from "geom/vec2";

export function vec2SequenceAngleCW(x0: number, y0: number, x1: number, y1: number, x2: number, y2: number) {
  const [dx0, dy0] = vec2Sub(x0, y0, x1, y1);
  const [dx1, dy1] = vec2Sub(x1, y1, x2, y2);

  const angle = vec2AngleBetweenCWSimple(dx1, dy1, dx0, dy0);
  return Math.abs(angle) < ANGLE_EPSILON ? 0 : angle;
}

interface GetPlanOutlineCenterVertexOptions {
  readonly planOutline: PolyLine2;
  readonly frontEdge: boolean;
}

export function getCenterPlanOutlineVertexAlongTraversal({
  planOutline,
  frontEdge,
}: GetPlanOutlineCenterVertexOptions): Vec2 {
  if (frontEdge) {
    return line2MidPt(planOutline[0], planOutline[1], planOutline[2], planOutline[3]);
  }
  return line2MidPt(planOutline[4], planOutline[5], planOutline[6], planOutline[7]);
}
